import React from "react";
import { Pages, ReduxFreeformActions } from "../../types";
import { Cluster, Title } from "@thecb/components";
import Navigation from "../../components/navigation";
import TerminalsTable from "./TerminalsTable";
import TerminalsTableControls from "./TerminalsTableControls";

interface Props {
  actions: {
    forms: {
      terminalsTableForm: {
        actions: ReduxFreeformActions;
      };
    };
  };
}

const TerminalsPage = ({ actions }: Props) => {
  return (
    <>
      <Title as="h1" weight="bold">
        Terminals
      </Title>
      <Cluster
        align="center"
        justify="space-between"
        extraStyles={`overflow: visible;`}
      >
        <Navigation page={Pages.TERMINALS} />
        <TerminalsTableControls actions={actions} />
      </Cluster>
      <TerminalsTable />
    </>
  );
};

export default TerminalsPage;
